<script lang="ts" setup>
import PanelGrid from "@/views/shared/components/PanelGrid.vue";
import PanelCard from "@/views/shared/components/PanelCard.vue";
import PageHeader from "@/components/PageHeader.vue";
import TestingConsole from "./TestingConsole.vue";

// The single embeddable Testing unit — a general capability for every project type, not publisher-only.
// As the top-level Testing page it renders standalone: wrapped in the PanelGrid/PanelCard shell like the
// other top-level pages, with its own PageHeader, org-wide across all the org's projects. Embedded in a
// project's Testing tab, a projectId is passed: data is scoped to that project, and both the panel shell
// AND the PageHeader are suppressed because the project view already supplies them. Authoring and batch
// regression live together on one page (TestingConsole) — no sub-tabs.
const props = defineProps<{ projectId?: string }>();
</script>

<template>
  <!-- Embedded in a project tab: render bare (the project view provides the panel + its own header). -->
  <TestingConsole v-if="props.projectId" :project-id="props.projectId" />

  <!-- Top-level page: same panel shell as the other main-menu pages. -->
  <main v-else>
    <PanelGrid :columns="1">
      <PanelCard>
        <div class="d-flex flex-column gap-4">
          <PageHeader
            title="Testing"
            :breadcrumbs="[{ label: 'Dashboard', href: '/' }, { label: 'Testing' }]"
          />
          <TestingConsole />
        </div>
      </PanelCard>
    </PanelGrid>
  </main>
</template>
